/**
 * Web implementation of BackHandler (mirrors react-native-web but without console.error)
 * BackHandler is Android-specific and doesn't apply to web
 */

function emptyFunction(): void {
  // no-op
}

const BackHandler = {
  exitApp: emptyFunction,
  addEventListener(): { remove: () => void } {
    // Silently return a no-op subscription (no console.error unlike react-native-web)
    return {
      remove: emptyFunction,
    };
  },
  removeEventListener: emptyFunction,
};

export default BackHandler;
